import util from '@/util'

export const obterImagem = (nomeImagem) => {
  try {
    const dataAtual = new Date()
    const dataAtualFormatada = util.formatarData(dataAtual, 'YYYYMMDDHHmm')
    const imagem = require(`@/assets/img/${nomeImagem}`)
    const imagemComCache = `${imagem}?data=${dataAtualFormatada}`

    return imagemComCache
  } catch (e) {
    return null
  }
}

export const obterIconeSite = () => {
  const hostName = window.location.host
  const obterIconeDaEmpresa = (hostName) => {
    switch (true) {
      case hostName.includes(process.env.VUE_APP_OFFICE_ADV_DOMAIN):
        return 'office.ico'
      case hostName.includes(process.env.VUE_APP_MIRT_DOMAIN):
        return 'mirt.svg'
      default:
        return 'office.ico'
    }
  }

  const nomeFavicon = obterIconeDaEmpresa(hostName)
  const caminhoFavicon = process.env.BASE_URL + nomeFavicon
  return caminhoFavicon
}

export const obterIcone = (nomeIcone) => {
  try {
    const icone = require(`@/assets/img/${nomeIcone}`)
    return icone
  } catch (e) {
    return null
  }
}
